/**
 * Utilitarios de plataforma para la conexión serial (Web Serial API)
 *
 * La Web Serial API en Android existe recién desde Chrome 138 (junio 2025)
 * y solo sobre Bluetooth RFCOMM/SPP (sin soporte USB). Además, Chrome Android
 * solo lista en requestPort() los dispositivos Bluetooth Classic ya emparejados
 * en los Ajustes del teléfono.
 *
 * Referencias: docs/SERIAL_DEVICES_GUIDE.md (sección Android)
 */

/** ¿Estamos en un dispositivo Android? (userAgentData con fallback a UA string) */
export const isAndroidDevice = (): boolean => {
  const uaData = (navigator as any).userAgentData;
  if (uaData?.platform) {
    return uaData.platform === 'Android';
  }
  return /Android/i.test(navigator.userAgent);
};

/** ¿Es Samsung Internet? (no soporta Web Serial) */
export const isSamsungInternet = (): boolean =>
  /SamsungBrowser/i.test(navigator.userAgent);

/** Mensaje cuando el navegador no soporta Web Serial en Android */
export const SERIAL_UNSUPPORTED_ANDROID =
  'Para conectar la balanza desde el celular necesitás Google Chrome actualizado (versión 138 o superior). Samsung Internet y Firefox no son compatibles. En celular solo funciona por Bluetooth, no por cable USB.';

/** Mensaje cuando el navegador no soporta Web Serial en desktop */
export const SERIAL_UNSUPPORTED_DESKTOP =
  'Este navegador no soporta la conexión con dispositivos seriales. Usá Google Chrome, Edge u Opera en una computadora.';

/** Hint de emparejamiento para Android (la balanza no aparece en la lista de requestPort) */
export const ANDROID_PAIRING_HINT =
  'Si la balanza no aparece en la lista, emparejala primero en Ajustes de Bluetooth del teléfono y volvé a intentar. Chrome solo muestra dispositivos ya emparejados.';

/** Aviso para Samsung Internet: no soporta Web Serial ni con la última versión */
export const SAMSUNG_INTERNET_HINT =
  'Samsung Internet no soporta la conexión con la balanza, ni por Bluetooth ni por cable. Abrí Mi Campo Digital en Google Chrome para conectarla.';
